import { css } from "styled-components";
import { Breakpoints } from "./media";

// NOTE(miyashiro): IntelliSense で値が表示できるメリットがあるので、固定値は enum で設定する
export enum colors {
  // wantedly color palette
  gray1 = "#9DA0A4",
  gray2 = "#6A6E71",
  gray3 = "#45494B",
  gray4 = "#24282A",
  gray5 = "#36393A",
  lightgray1 = "#EBEDEF",
  lightgray2 = "#D7DBDF",
  lightergray1 = "#f5f5f5",
  lightergray2 = "#f9f9f9",
  lightergray3 = "#f0f0f0",
  slateGray = "#45494b",
  blue1 = "#00A4BB",
  blue2 = "#006F8E",
  red1 = "#FF3333",
  red2 = "#F55B3E",
  red3 = "#c12626",
  green1 = "#6CC644",
  yellow1 = "#FED100",
  yellow2 = "#FFE675",
  lightyellow1 = "#F7F5DF",
  bluegray1 = "#E8EFF0",
  lightred1 = "#FCC",
  lightred2 = "#FEE",

  layoutLightBorder = "#e3e3e3",
  buttonNewLightgray = "#f5f5f5",
  buttonNewLightgrayBorder = "#ddd",
  buttonNewBlueBorder = "#1e7785",
  buttonNewGreenBorder = "#4f8338",
  buttonNewRed = "#e04747",
  buttonNewRedBorder = "#a33f3f",
  buttonNewYellowBorder = "#d4b318",

  twitterText = "#4099FF",

  facebookText = "#3b5998",
  facebookLoginButton = "#4060a0",
  facebookLoginButtonBorder = "#303d57",

  linkedinText = "#008cc9",
  linkedinLoginButton = "#0077b5",
  linkedinLoginButtonBorder = "#303d57",

  selectedBlue = "#56b5c2",
  lightTextGray = "#ccc",
  footerBgColor = "#f0f4f5",

  gradationBlue = "linear-gradient(to right, #1b85dc, #08b0cb)",

  // iOS color
  grayTextColor = "#656f72",
  green2 = "#89d169",
  wtdBlueColor = "#19adc2",
  highlightedBackgroundColor = "#e8f7f9",
}

export const textStyle = css`
  font-family: "Helvetica Neue", "Helvetica", "Arial", "游ゴシック体", "Yu Gothic", "YuGothic", "Hiragino Sans",
    "ヒラギノ角ゴシック", "Hiragino Kaku Gothic ProN", "ヒラギノ角ゴ Pro W3", "Roboto", "メイリオ", "Meiryo",
    "ＭＳ Ｐゴシック", "sans-serif";
  color: ${colors.gray4};
`;

export const lato = css`
  font-family: "Lato", "Helvetica Neue", Helvetica, "Hiragino Sans", "ヒラギノ角ゴシック Pro",
    "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, Osaka, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
`;

// Use `em` for media query. See: https://zellwk.com/blog/media-query-units/
const px2em = (px: number): number => px / 16;

export const media = {
  small: `screen and (max-width: ${px2em(Breakpoints.medium - 1)}em)`,
  medium: `screen and (min-width: ${px2em(Breakpoints.medium)}em)`,
  large: `screen and (min-width: ${px2em(Breakpoints.large)}em)`,
  greaterThan: (px: number) => `screen and (min-width: ${px2em(px + 1)}em)`,
  smallerThan: (px: number) => `screen and (max-width: ${px2em(px)}em)`,
};

export const truncateLine = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

// Specifies max-height for fallback for non-WebKit browsers.
export function truncateLines(rows: number, fontSize = 14, lineHeight = 1.5) {
  return css`
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: ${lineHeight};
    font-size: ${fontSize}px;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${rows};
    max-height: ${rows * fontSize * lineHeight}px;
  `;
}

export interface RGB {
  r: number;
  g: number;
  b: number;
}

export function convertHexToRGB(code: string) {
  const result = /^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(code);
  const color: RGB | null = result
    ? { r: parseInt(result[1], 16), g: parseInt(result[2], 16), b: parseInt(result[3], 16) }
    : null;
  return color;
}



// WEBPACK FOOTER //
// ./frontend/src/common/utils/style.ts